#import "~/graphql/fragments/Assets/DefaultImageAsset.graphql"

fragment ContentBlockImages on contentBlocks_images_BlockType {
    title: sectionTitle

    images {
        ... DefaultImageAsset
    }

    anchorId
    anchorLabel
}
